module.exports = __webpack_public_path__ + "img/wind.2deeedb5.png";